// SignalR group names. These MUST match the server's NotificationGroups
// (src/api/KeyDials.Api/Realtime/NotificationGroups.cs) — see groups.test.ts.
export const groups = {
  org: (organisationId: string) => `org:${organisationId}`,
  instance: (instanceId: string) => `instance:${instanceId}`,
  section: (instanceId: string, sectionKey: string) => `instance:${instanceId}:section:${sectionKey}`,
  segment: (instanceId: string, sectionKey: string, segmentKey: string) =>
    `instance:${instanceId}:segment:${sectionKey}:${segmentKey}`,
};
